//['MODULE STOCK', 'MODULE VENTE', 'MODULE RESEAU', 'MODULE PTBA']
export const hasAccessPTBA = (modules = [])=> modules.includes("MODULE PTBA")
export const hasAccessStock = (modules = [])=> modules.includes("MODULE STOCK")
export const hasAccessVente = (modules = [])=> modules.includes("MODULE VENTE")
export const hasAccessReseau = (modules = [])=> modules.includes("MODULE RESEAU")